module.exports = __webpack_public_path__ + "static/media/cupcakePumpkin.c390b6ba.jpg";